import { Link } from '@/libs/router'

type OverviewWidgetCardProps = {
	label: string
	value: string
	detail?: string
	href: string
}

const OverviewWidgetCard = ({ label, value, detail, href }: OverviewWidgetCardProps) => (
	<Link
		to={href}
		className='h-full border p-5 flex flex-col justify-between transition-all duration-300 bg-background border-e6e6e6 hover:bg-f7f7f7 hover:border-d0d0d0 cursor-pointer min-h-[110px]'
	>
		<span className='text-xs text-muted-foreground'>{label}</span>
		<div className='mt-3'>
			<span className='text-xl font-medium'>{value}</span>
			{detail ? <span className='text-xs text-muted-foreground ml-2'>{detail}</span> : null}
		</div>
	</Link>
)

export { OverviewWidgetCard }
